import { render, staticRenderFns } from "./BusinessContactTopicForm.vue?vue&type=template&id=36fd4506"
import script from "./BusinessContactTopicForm.vue?vue&type=script&lang=js"
export * from "./BusinessContactTopicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports